<template>
  <div class="mode-switch">
    <label class="switch">
      <input type="checkbox" v-model="isSimulation" @change="emitChange" />
      <span class="slider"></span>
    </label>
    <div class="mode-label">{{ isSimulation ? $t('vp.simulation') : $t('vp.experiment') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: 'experiment'
    }
  },
  data() {
    return {
      isSimulation: this.value === 'simulation'
    };
  },
  methods: {
    emitChange() {
      const newValue = this.isSimulation ? 'simulation' : 'experiment';
      this.$emit('input', newValue);
    }
  }
};
</script>

<style scoped>
.mode-switch {
  display: flex;
  align-items: center;
}

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
  margin-right: 10px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked+.slider {
  background-color: #4caf50;
}

input:checked+.slider:before {
  transform: translateX(26px);
}

.mode-label {
  font-size: 16px;
  color: #333;
}
</style>
